import i18n from '../i18n';

/**
 * Pick the localized field from a backend object that has _ro/_en suffixed fields.
 * Falls back: current lang field → other lang field → base field → fallback.
 *
 * Usage: localized(technique, 'technique_name')
 *   - if lang=ro → technique.technique_name_ro || technique.technique_name_en || technique.technique_name || technique.name
 *   - if lang=en → technique.technique_name_en || technique.technique_name_ro || technique.technique_name || technique.name
 */
export function localized(obj: any, fieldBase: string, fallbackField?: string): string {
  if (!obj) return '';
  const lang = i18n.language?.startsWith('ro') ? 'ro' : 'en';
  const other = lang === 'ro' ? 'en' : 'ro';

  // Try fieldBase_lang (e.g. technique_name_ro), then fallbackField_lang (e.g. name_ro)
  return (
    obj[`${fieldBase}_${lang}`] ||
    (fallbackField ? obj[`${fallbackField}_${lang}`] : '') ||
    obj[`${fieldBase}_${other}`] ||
    (fallbackField ? obj[`${fallbackField}_${other}`] : '') ||
    obj[fieldBase] ||
    (fallbackField ? obj[fallbackField] : '') ||
    ''
  );
}

/**
 * Pick explanation based on current language.
 * Backend sends explanation_ro and explanation_en on verdict.
 */
export function localizedExplanation(obj: { explanation_ro?: string; explanation_en?: string }): string {
  if (!obj) return '';
  const isRo = i18n.language?.startsWith('ro');
  return (isRo ? obj.explanation_ro : obj.explanation_en) ||
         obj.explanation_en || obj.explanation_ro || '';
}
